import { deepClone } from '@/utils/index'

class AssemblyPlanUtils {
  /**
   * 获取航次
   * @param airlineProductDownList
   * @param assemblyPlan
   * @returns {null|*}
   */
  static getProductVoyage(airlineProductDownList, assemblyPlan) {
    if (airlineProductDownList && airlineProductDownList.length > 0) {
      const airlineProduct = airlineProductDownList.find(p => p.uuid === assemblyPlan.airlineProductUuid)
      if (airlineProduct &&
          assemblyPlan.flightDate >= airlineProduct.beginDate && assemblyPlan.flightDate <= airlineProduct.endDate &&
          airlineProduct.voyages && airlineProduct.voyages.length > 0) {
        const weekday = new Date(assemblyPlan.flightDate).getDay() || 7
        return airlineProduct.voyages.find(p => p.voyage === weekday)
      }
    }
    return null
  }

  static bringDataFromAirlineProduct(airlineProductDownList, assemblyPlan) {
    assemblyPlan.serviceProduct = ''
    assemblyPlan.carrierId = 0
    assemblyPlan.basicWeight = 0
    assemblyPlan.limitWeight = 0
    assemblyPlan.availableCabinSpace = 0
    assemblyPlan.theoryVolume = 0
    assemblyPlan.sellableVolume = 0
    assemblyPlan.assemblyPlanCosts = []
    // 根据 【航线产品】 带出
    if (airlineProductDownList && airlineProductDownList.length > 0) {
      const airlineProduct = airlineProductDownList.find(p => p.uuid === assemblyPlan.airlineProductUuid)
      if (airlineProduct) {
        // 根据 【航线产品】 带出【服务产品、航司】
        assemblyPlan.serviceProduct = airlineProduct.serviceProduct
        assemblyPlan.carrierId = airlineProduct.carrierId
        if (assemblyPlan.flightDate && airlineProduct && airlineProduct.voyages && airlineProduct.voyages.length > 0) {
          const weekday = new Date(assemblyPlan.flightDate).getDay() || 7
          const productVoyage = airlineProduct.voyages.find(p => p.voyage === weekday)
          if (productVoyage) {
            // 根据 【航线产品】 带出 【限重、理论体积】
            assemblyPlan.basicWeight = productVoyage.basicWeight || 0.0
            assemblyPlan.limitWeight = productVoyage.limitWeight || 0.0
            assemblyPlan.availableCabinSpace = productVoyage.availableCabinSpace || 0.0
            assemblyPlan.theoryVolume = productVoyage.theoryVolume || 0.0
            assemblyPlan.sellableVolume = productVoyage.sellableVolume || 0.0
            // 根据 【航线产品】 带出 【成本】
            if (productVoyage.voyageCosts && productVoyage.voyageCosts.length > 0) {
              const assemblyPlanCosts = deepClone(productVoyage.voyageCosts)
              assemblyPlanCosts.forEach(p => {
                p.uuid = null
              })
              assemblyPlan.assemblyPlanCosts = assemblyPlanCosts
            }
          }
        }
      }
    }
  }
}
export default AssemblyPlanUtils
